import React, { useState, useEffect } from "react";
import { Cookies } from "../../index.js";
import { alert_error, alert_success, copy_native } from "../../AppContext";
import { useSelector, useDispatch } from 'react-redux';
import { update_open_button_support, update_users_status } from '../../order/orders/actions.js';

const codeSnippets = {
    0: `Đang tải`,
    1: `POST api: {API_URL}
{
"action": "add",
"comments": ["comment_1", "comment_2", ... ],
"key": {API_KEY},
"link": {link},
"quantity": {quantity},
"service": {id_service}
}
Response:
{ "order": 23501 }
`,
    2: `POST api: {API_URL}
{
"key": "{API_KEY}",
"action": "status" ,
"orders" : "Order IDs (separated by a comma, up to 100 IDs)"
}`,
    3: `F12 reveals everything =))`,
    4: `{
"key": "{API_KEY}",
"action": "services"
}`,
    5: `{
"key": "{API_KEY}",
"action": "status" ,
"order" : "Order ID"
}`,
    6: `{
"status": "success",
"msg": "Order created successfully!",
"trans_id": "{id_orders}",
"data": [
    "1000040304952|GUTJXYIFPWLHCNDOMBRKVAQESZ",
    "1000087676467|IVMRLABECWTQYUXHPOFNJDSZGK",
    "1000073612513|ERKPFTVCAJDLINWMXSUOGBQZHY",
    "1000011975745|JXEZTVLYOFBQNRHGDKMIPUCAWS"
]
}`,
    7: `{
"api_key": "{API_KEY}",
"action": "buyProduct",
"id": "{id_service}",
"amount": "Quantity to purchase"
}`,
    8: `Get api: {Url_Main}/api/orders/account/sellers/lists.php?category=accounts_seller&apikey={API_KEY}&accounts_type="local or api"
Response:
{[
    {
        "id": {id_service},
    } , ...
]}`,
    9: `Post api: {API_URL}
json Post:
{
    "action":"add",
    "key":"{API_KEY}",
    "link":
    {
        "accounts_caption":{accounts_caption},
        "accounts_description":{accounts_description},
        "accounts_type":"local or api"
    },
    "quantity":1,
    "service":"625679"
}
Response:
{order: {id_order}}
`,
    10: `POST api: {Url_Main}/getservice/service.php
json Post:
{
    "category": {category},
    "apikey": "{API_KEY}",
    "servicecode": "accounts",
    "mode": "info"
}
Response:
Info product
`,
    11: `GET api: 
{Url_Main}/api/orders/account/sellers/services/services_category_lists.php
Response: {category}`,
    12: `POST api: 
{Url_Main}/getservice/service.php
json Post:
{
    "apikey": {API_KEY},
    "category": "{category}",
    "mode": "info",
    "servicecode": "accounts"
} 
Response: 
{info: "...", data: [...]}` ,
    13: `GET api: 
{Url_Main}/api/orders/account/sellers/services/services_info.php?id={id}
Response: {id_service}`,
    14: `POST api: {API_URL}
{
"action": "buyProduct",
"key": {API_KEY},
"quantity": {quantity},
"service": {id_service}
}Response: 
{
    "status": "success",
    "msg": "Order created successfully!",
    "trans_id": "{id_orders}",
    "data": [
        "1000040304952|GUTJXYIFPWLHCNDOMBRKVAQESZ",
        "1000087676467|IVMRLABECWTQYUXHPOFNJDSZGK",
    ...
    ]
}` , 15: `Get api: {Url_Main}/api/orders/account/sellers/lists.php?category=accounts_orders&apikey={API_KEY}
Response:
{[
    {
        "id": {id_orders},
    } , ...
]}` , 16: `Get api: {Url_Main}/getservice/accounts_history.php?listtrang=1&apikey={API_KEY}
Response:
{[
    {
        "id": {id_orders},
    } , ...
]}`,
    17: `Post api: {Url_Main/api/orders/account/sellers/services/accounts_edit.php`
};


export default function Api_docs({ category }) {
    const open_button_support = useSelector(state => state.open_button_support);
    const dispatch = useDispatch();

    const set_open_button_support = (value) => {
        dispatch(update_open_button_support(value));
    };
    const [api_lists, set_api_lists] = useState([
        { title: "Add order", snippet: codeSnippets[0], bg: "bg-pink-200", preTextColor: "text-gray-900" }
    ]);

    const myCookieValue = Cookies.get("apikey");

    useEffect(() => {
        if (category === "servers_orders") {
            set_api_lists([
                { title: "Add order", snippet: codeSnippets[1], bg: "bg-pink-200", preTextColor: "text-gray-900" },
                { title: "Service list", snippet: codeSnippets[4], bg: "bg-pink-200", preTextColor: "text-gray-900" },
                { title: "Action: Order status", snippet: codeSnippets[5], bg: "bg-pink-200", preTextColor: "text-gray-900" },
                { title: "Multiple orders status", snippet: codeSnippets[2], bg: "bg-pink-200", preTextColor: "text-gray-900" },
                { title: "Professional", snippet: codeSnippets[3], bg: "bg-pink-50", preTextColor: "text-pink-700" }
            ]);
        } else if (category === "accounts_seller_api") {
            set_api_lists([
                { title: "Add new product", snippet: codeSnippets[9], bg: "bg-pink-200", preTextColor: "text-gray-900" },
                { title: "Get product list", snippet: codeSnippets[8], bg: "bg-pink-200", preTextColor: "text-gray-900" },
                { title: "Edit product list", snippet: codeSnippets[17], bg: "bg-pink-200", preTextColor: "text-gray-900" },
                { title: "Purchase API data sent to you", snippet: codeSnippets[7], bg: "bg-pink-200", preTextColor: "text-gray-900" },
                { title: "json you return to the client", snippet: codeSnippets[6], bg: "bg-pink-200", preTextColor: "text-gray-900" },
                { title: "Professional", snippet: codeSnippets[3], bg: "bg-pink-50", preTextColor: "text-pink-700" }
            ]);
        } else if (category === "accounts_seller_history") {
            set_api_lists([
                { title: "accounts_seller_history", snippet: codeSnippets[15], bg: "bg-pink-200", preTextColor: "text-gray-900" },
                { title: "Professional", snippet: codeSnippets[3], bg: "bg-pink-50", preTextColor: "text-pink-700" }
            ]);
        } else if (category === "accounts_product_services") {
            set_api_lists([
                { title: "Get lists category", snippet: codeSnippets[11], bg: "bg-pink-200", preTextColor: "text-gray-900" },
                { title: "Get lists services", snippet: codeSnippets[12], bg: "bg-pink-200", preTextColor: "text-gray-900" },
                { title: "Get info product", snippet: codeSnippets[10], bg: "bg-pink-200", preTextColor: "text-gray-900" },
                { title: "Professional", snippet: codeSnippets[3], bg: "bg-pink-50", preTextColor: "text-pink-700" }
            ]);
        } else if (category === "accounts_product_orders") {
            set_api_lists([
                { title: "Get info service", snippet: codeSnippets[13], bg: "bg-pink-200", preTextColor: "text-gray-900" },
                { title: "Orders service", snippet: codeSnippets[14], bg: "bg-pink-200", preTextColor: "text-gray-900" },
                { title: "Orders history", snippet: codeSnippets[16], bg: "bg-pink-200", preTextColor: "text-gray-900" },
                { title: "Professional", snippet: codeSnippets[3], bg: "bg-pink-50", preTextColor: "text-pink-700" }
            ]);
        }
    }, []); // không include rawText để tránh loop

    function copyText(value) {
        if (!value) return alert_error?.("No text to copy");
        copy_native(value);
        alert_success?.("Copied to clipboard");
    }

    return (
        <>
            <div className="mt-2 mx-2 sm:mx-4">
                <div className="mx-auto max-w-xl sm:max-w-2xl">
                    <form className="add-form">
                        <div className="form-control">
                            {/* --- Replace old header card with this --- */}
                            <div className="bg-white shadow-sm rounded-xl overflow-hidden mb-2 mt-1 border border-gray-100">
                                {/* top area: tiêu đề + mô tả (giữ padding để header đẹp) */}
                                <div className="px-2 py-0 mt-1">
                                    <div className="text-2xl font-semibold text-gray-800">API Docs</div>
                                    <div className="mt-0 text-sm text-gray-600">
                                        Shortcuts & examples for talking to the API. Tap{" "}
                                        <span className="font-semibold">Copy</span> to copy the JSON/params.
                                    </div>
                                </div>
                                <div className="rounded-xl overflow-hidden">
                                    {/* Hàng 1 */}
                                    <div className="flex justify-between items-center py-1 mx-2 border-t border-gray-200">
                                        <span className="text-sm text-pink-500">HTTPs Method</span>
                                        <span className="inline-block bg-indigo-100 text-indigo-700 font-semibold px-3 py-1 rounded-full text-sm">
                                            POST, GET
                                        </span>
                                    </div>

                                    {/* Hàng 2 */}
                                    <div className="flex justify-between items-center py-1 mx-2 border-t border-gray-200">
                                        <span className="text-sm text-pink-500">{`{Url_Main}`}</span>
                                        <code className="inline-block bg-gray-100 text-gray-800 px-3 py-1 rounded-lg select-all text-sm">
                                            {window.location.origin}
                                        </code>
                                    </div>

                                    {/* Hàng 3 */}
                                    <div className="flex justify-between items-center py-1 mx-2 border-t border-gray-200">
                                        <span className="text-sm text-pink-500">{`{API_URL}`}</span>
                                        <code className="inline-block bg-gray-100 text-gray-800 px-3 py-1 rounded-lg select-all text-sm">
                                            {`${window.location.origin}/api/v3`}
                                        </code>
                                    </div>

                                    {/* Hàng 4: 2 box song song */}
                                    <div className="flex w-full">
                                        {/* left box */}
                                        <div className="flex-1 p-1 mx-2 font-mono text-sm break-all text-gray-800 border-t border-r border-gray-200">
                                            <div className="text-sm text-pink-500">Your {'{API_KEY}'}</div>
                                            <div className="mt-1 text-sm">
                                                {myCookieValue || "••••••••••••••••••••"}
                                            </div>
                                        </div>

                                        {/* right box */}
                                        <div className="flex-1 p-1 mx-2 text-sm border-t border-gray-200">
                                            <div className="text-sm text-pink-500">Response format</div>
                                            <div className="mt-1 font-semibold">JSON</div>
                                        </div>
                                    </div>
                                </div>

                            </div>


                            {/* List snippets */}
                            <div className="space-y-2">
                                {api_lists.map((b, idx) => (
                                    <div key={idx} className="rounded-xl overflow-hidden border border-transparent">
                                        {/* header của item: vẫn dùng b.bg và b.preTextColor như cũ */}
                                        <div
                                            className={`flex items-center justify-between p-2 ${b.bg} bg-opacity-80 shadow-md rounded-t-xl`}
                                        >
                                            <div className="flex items-start">
                                                <div className="mr-3 mt-0.5">
                                                    {/* subtle badge (không đổi màu gốc) */}
                                                    <span className="inline-block w-3 h-3 rounded-full ring-2 ring-white/70" />
                                                </div>
                                                <div>
                                                    <div className="text-sm font-semibold text-gray-800">{b.title}</div>
                                                    <div className="text-xs text-gray-600">Json or Param for API</div>
                                                </div>
                                            </div>

                                            <div className="flex items-center space-x-2">
                                                <button
                                                    type="button"
                                                    className="inline-flex items-center text-xs font-medium px-3 py-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-200 shadow-sm active:scale-95 transition"
                                                    onClick={() => copyText(b.snippet)}
                                                >
                                                    📋 Copy
                                                </button>

                                                <button
                                                    type="button"
                                                    className="inline-flex items-center text-xs font-medium px-3 py-1.5 rounded-lg bg-white/90 hover:bg-white text-gray-800 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-100 shadow-sm active:scale-95 transition"
                                                    onClick={() => set_open_button_support(!open_button_support)}
                                                >
                                                    💬 Support
                                                </button>
                                            </div>
                                        </div>
                                        {/* body: giữ b.preTextColor nhưng làm scroll/line-height thân thiện dth */}
                                        <div
                                            className={`p-3 ${b.bg} border-t border-gray-800 rounded-b-xl`}
                                            style={{ boxShadow: '0 6px 18px rgba(12,12,15,0.04)' }}
                                        >
                                            <pre
                                                className={`whitespace-pre-wrap ${b.preTextColor} text-sm leading-6 font-mono`}
                                                style={{
                                                    overflowX: 'auto',
                                                    margin: 0,
                                                    maxHeight: 340,
                                                    WebkitOverflowScrolling: 'touch'
                                                }}
                                            >
                                                {b.snippet}
                                            </pre>
                                        </div>



                                    </div>
                                ))}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <br />
        </>
    );
}
